import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { Wrap, HDate, HeaderWrap, Arrows } from './styles';
import { WEEK } from '../../utils';
import Icon from '../../../../components/Icon';

const isSelectedDate = (headerDate, startDate, viewBy) => {
  return viewBy === WEEK
    ? moment(startDate).format('YY-MM-DD') ===
        moment(headerDate).format('YY-MM-DD')
    : moment(startDate).format('YY-MM') === moment(headerDate).format('YY-MM');
};

const getDuration = viewBy => {
  return { amount: 1, unit: viewBy === WEEK ? 'd' : 'M' };
};

const Header = ({ headers, startDate, setStartDate, viewBy }) => {
  const duration = getDuration(viewBy);

  const onArrowClick = direction => {
    const moveTo = {
      left: () => {
        const newDate = moment(startDate)
          .subtract(duration.amount, duration.unit)
          .toDate();
        setStartDate(newDate);
      },
      right: () => {
        const newDate = moment(startDate)
          .add(duration.amount, duration.unit)
          .toDate();
        setStartDate(newDate);
      },
    };

    moveTo[direction]();
  };
  return (
    <Wrap>
      <HeaderWrap>
        {headers.length > 0 && (
          <Arrows>
            <Icon name="<" onClick={() => onArrowClick('left')} />
            <Icon name=">" onClick={() => onArrowClick('right')} />
          </Arrows>
        )}
        {headers.map(({ id, format, momentDate, date }) => (
          <HDate
            key={id}
            divideBy={headers.length}
            isSelectedDate={isSelectedDate(date, startDate, viewBy)}
          >
            {momentDate.format(format).toUpperCase()}
          </HDate>
        ))}
      </HeaderWrap>
    </Wrap>
  );
};

Header.propTypes = {
  viewBy: PropTypes.number,
  startDate: PropTypes.instanceOf(Date).isRequired,
  setStartDate: PropTypes.func.isRequired,
  headers: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.instanceOf(Date).isRequired,
      format: PropTypes.string,
      id: PropTypes.number,
    }),
  ).isRequired,
};

Header.defaultProps = {
  viewBy: null,
};

export default Header;
